module.exports = __webpack_public_path__ + "media/images/wiz_newbanner-70c13be46d91cd71eaa5aea4e0089193.png";